<script>
  import SectionRenderer from '../components/SectionRenderer.vue';
  import sections from './sections.json';
  import { HashScrollMixin } from '@/views/app/dashboard/footer-pages/components/HashScrollMixin';

  export default {
    name: 'HelpCenter',
    components: { SectionRenderer },
    mixins: [HashScrollMixin],
    data: () => ({
      sections,
      isScrolling: false,
    }),
    metaInfo() {
      return {
        title: 'Help Center',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
  };
</script>
<template>
  <div class="page-container">
    <div class="page">
      <!--      <Quicklinks :sections="sections" @click="scrollIntoView" />-->
      <div class="content">
        <h1 class="mb-8">HELP CENTER</h1>
        <span class="white--text">The quickest way to find the answer to your question is through our FAQs.</span>
        <section-renderer class="mt-15" :sections="sections" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '../components/style.scss';

  ::v-deep {
    .v-expansion-panels {
      margin-bottom: 40px !important;
    }
  }
</style>
